module.exports = __webpack_public_path__ + "static/media/16.f325c38c.mp3";